// app/ScrollToTop.js
"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

export default function ScrollToTop() {
  const pathname = usePathname();
  const isFirstRender = useRef(true); // merkt sich Mount‑Phase

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false; // ab jetzt kein Erst‑Render mehr
      return; // ⇒ beim Load NICHT scrollen
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
